import React, { Component } from 'react';
import { CloseOutlined, CloudUploadOutlined, DeleteOutlined, FileFilled, RedoOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox } from 'antd';
import moment from 'moment';
// import Uploadlayer from '../../../components/FormComponent/Input/upload';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from '../../../services/local-store';
import formDataPostService from '../../../services/httpformData';
import userTrackService from '../../../services/usertrack-service';

const $ = require('jquery');
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class AdmissionAdvices extends Component {

    constructor(props) {
        super(props);
        this.state = {

        //   tableData:[],
        //   selectedCheckboxes: [],
        //   modal1Visible:false,
        //   showValidationMessage: false, // Initially hide the validation message,
        //   savebuttonVisible:false
        tableData: [], // Your table data
        selectedCheckboxes: [], // Selected checkboxes
        modal1Visible:false,
        savebuttonVisible: false, // Save button visibility
        isSelectAllChecked: false, // Select All checkbox state
        checkboxesDisabled: false,
        activePage: 1,
        totalItemsCount: 0,
        downloadStatus: 0,
        'thead': [],
        'tbody': [],
        downloadtbody: [],
        commentModal: false,
        comments: null,
        patient_details: {},
        commentsArray: [],
        dateTo: moment().add(3, 'd').format('YYYY-MM-DD'),
        dateFrom: moment().format('YYYY-MM-DD'),
        callformSchema: [],
        };
      }
      
componentDidMount() {
    let counselling_view = JSON.parse(localStorage.getItem('counselling_view'));
    const fc_checklist_verified = counselling_view && counselling_view.length > 0
    ? counselling_view[0].fc_checklist_verified 
    : false;
    this.setState({counselling_view: counselling_view,savebuttonVisible:false});
    if(counselling_view && counselling_view.length && counselling_view[0].fc_checklist_verified){
        Storage.store('fc_checklist_verified', fc_checklist_verified);
    }
    console.log("this.state--this.state", this.state, this.props);
}

    componentWillUnmount() {
        this.setState({
            visible: false,
        });
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            let {ip_no, umr_no} = this.props.basic_info;
            console.log("this.props.basic",this.props.basic_info);
            let tableHead = [];
            tableHead = [
                {
                    "key":'umr_no',
                    'label':'UMR:'
                },
                {
                    "key":'ip_no',
                    'label':'IP Number:'
                },
                {
                    "key":'patient_name',
                    'label':'Patient Name:'
                },
                {
                    "key":'patient_phno',
                    'label':'Patient Phone:'
                },
                {
                    "key":'patient_age',
                    "label":'Age:'
                },
                {
                    "key":'patient_gender',
                    'label':'Gender:'
                },
                {
                    "key":'ref_doctor_name',
                    'label':'Ref Doctor Name:'
                },
                {
                    "key":'is_admission_advised',
                    'label':'Is Admission Advised:'
                },
                {
                    "key":'estimated_admission_date',
                    'label':'Estimated Date Of Admission:'
                },
                {
                    "key":'remarks',
                    'label':'Remarks:'
                },
                {
                    "key":'created_at',
                    'label':'Advised Date:'
                },
                {
                    "key":'updated_at',
                    'label':'Modified Date:'
                },
                // {
                //     "key":'is_counselling_done',
                //     'label':'Is Counselling Done'
                // },
                {
                    "key":'unitname',
                    'label': 'Unit Name:'
                },
                {
                    "key":'los_wards',
                    'label': 'LOS Wards:'
                },
                {
                    "key":'los_icu',
                    'label': 'LOS ICU:'
                },
                {
                    "key":'op_investigations',
                    'label': 'OP Investigations:'
                },
                {
                    "key":'op_procedures',
                    'label': 'OP Procedures:'
                },
                {
                    "key":'implant_cost',
                    'label': 'Implant Cost:'
                },
                {
                    "key":'total_estimated_cost',
                    'label': 'Total Estimated Cost:'
                },
                {
                    "key":'surgeries',
                    'label': 'Surgeries:'
                },
                {
                    "key":'professional_fees',
                    'label': 'Professional Fees:'
                },
                {
                    "key":'department_type',
                    'label': 'Care Management'
                }
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            this.setState((state) => ({ downloadStatus: 0, tbody: [], tableTitle: 'Admissions Advised', thead: tableHead, loadding: true, filename: 'Admission-Advised-Report.csv' }), () => {
                postService('getAdmissionAdvises', 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": "",
                        "from": '',
                        "to": '',
                        "umr_no":umr_no ? umr_no : null,
                        "ip_no":ip_no,
                        "advicesFlag": 1
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                if (dataKey === 'admission_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if (dataKey === 'latest_counselled_date') {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                                }
                                if(dataKey === 'department_type'){
                                    res.data[key][dataKey] = res.data[key][dataKey] === 'medical_department' ? 'Medical' : 'Surgical'
                                }



                            })
                        })
                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                        // enable downloadbtn after 2sec
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    setModal1Visible(modal1Visible) {
            this.setState({ modal1Visible})
        this.loadPage()
    }

    cancelButton = (modal1Visible) => {
        this.setState({ modal1Visible,});
    }  

    renderListRows = () => {
        const { thead, tbody } = this.state;
        return (
            <div>
                {tbody.map((row, rowIndex) => (
                    <div 
                        key={rowIndex} 
                        style={{
                            backgroundColor: '#f9f9f9',
                            padding: '35px',
                            marginBottom: '15px',
                            border: '1px solid #ddd',
                            borderRadius: '5px'
                        }}
                    >
                        {thead.map((col, colIndex) => (
                            <p 
                                key={colIndex} 
                                style={{ margin: '8px 0', fontSize: '16px', color: '#333' }}
                            >
                                <strong>{colIndex + 1}.&nbsp;&nbsp;{col.label}</strong> {row[col.key] || "-"}
                            </p>
                        ))}
                    </div>
                ))}
            </div>
        );
    };
        
    
    render() {
        console.log("PatientCheckIN");
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days,
            current_counselling_id, latest_counselling_id,savebuttonVisible,counselling_view,selectedCheckboxes, tableData } = this.state
        let pat_doc_ids = []
        const { id, slug } = this.props.match.params
      
        const desiredLength = tableData.length;
        const allCheckboxesSelected = selectedCheckboxes.length === desiredLength;
        return (<React.Fragment>
            {slug === 'patients-history-details' || slug === 'pending-docs' || slug === 'pre-auth-worklist' ? null : <React.Fragment> {showDocument ?
                <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-ena`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                    {/* this.initial() */}
                    <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                    <p className="mt-2 mb-0">Patient Admission Advices</p>
                </div>
                :
                <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-dis`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                    <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                    <p className="mt-2 mb-0">Patient Admission Advices</p>
                </div>
            }</React.Fragment>}
            {tbody && tbody.length > 0 ? 
            <Modal
                centered
                visible={this.state.modal1Visible}
                onCancel={() => this.setModal1Visible(false)}
                width='65%'
                height='65%'
                footer={null}
            >
                <CloseOutlined type="close" className=" popup-close" onClick={() => this.cancelButton(false)}/>
                {ui_form_type === 'view' && disable_15days == true ?
                    <React.Fragment>
                        <h4 className="text-center">Patient Admission Advices From EHR</h4>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <h4 className="text-center">Patient Admission Advices From EHR</h4>
                    </React.Fragment>}
                {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0, zIndex: 9999 }}> <Spin ></Spin></div>}
                <div className="financial-table table-responsive pop-table">
                    <table style={{ borderCollapse: 'separate', borderSpacing: '0 10px', width: '100%' }}>
                        <tbody>
                            {this.renderListRows()}
                        </tbody>
                    </table>
                </div>
            </Modal> 
            : null
            }
        </React.Fragment>)
    }
}
export default AdmissionAdvices;